<template>
  <div class="el-header">
    <el-menu
      id="menu"
      :default-active="
        this.$route.path.split('/')[1] == ''
          ? 'null'
          : '/' + this.$route.path.split('/')[1]
      "
      class="el-menu-demo"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#fff"
      background-color="transparent"
      router
    >
      <el-menu-item id="logo_hover" index="/index">
        <el-image
          style="width: 163px; height: 29px"
          :src="logoUrl"
          fit="cover"
        ></el-image>
      </el-menu-item>
      <el-menu-item class="no_active">
        <a class="SmartEarth_active" href="http://www.smartearth.cn/"
          >SmartEarth</a
        >
      </el-menu-item>
      <el-menu-item index="/dataCollection">数据采集</el-menu-item>
      <el-menu-item index="/dataProcessingOrder">数据处理</el-menu-item>
      <el-menu-item index="/solution">解决方案</el-menu-item>
      <el-menu-item index="/acquisitionProcessing">一站式服务</el-menu-item>
      <el-menu-item index="/taiRuiCollege">泰瑞学院</el-menu-item>
      <el-menu-item index="/softwareCenter">软件中心</el-menu-item>
      <el-menu-item class="no_active" @click="baoxian()">空域服务</el-menu-item>
      <el-menu-item class="no_active" @click="baoxian()">保险服务</el-menu-item>
      <el-menu-item
        class="no_active"
        index="/login"
        id="user_hover"
        style="float: right;"
      >
        <el-button type="primary" size="mini" v-if="this.token == null"
          >点击注册/登陆</el-button
        >
      </el-menu-item>
      <el-menu-item
        class="no_active"
        v-if="this.token !== null"
        id="user_hover"
        style="float: right;padding:0;"
      >
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="el-dropdown-link">
            {{ reversedMessage }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1" icon="el-icon-s-custom"
              >企业信息</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-error" command="2"
              >退出登陆</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-avatar size="medium" :src="imgUrl"> </el-avatar>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    toUpdate: Boolean
  },
  data() {
    //这里存放数据
    return {
      logoUrl: require("../assets/img/logo.png"),

      routerPath: "",
      testData: {},
      imgUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      username: "",
      token: window.sessionStorage.getItem("userId")
    };
  },
  //方法集合
  //方法集合
  methods: {
    baoxian() {
      this.$message("程序猿正在快马加鞭的开发中！！");
    },

    //登陆传输data
    async getRouterData() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };

      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );

      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }

      this.testData = dt.data;
      window.sessionStorage.setItem("userType", this.testData.type);
      this.username = this.testData.username;
      this.testData.data = JSON.parse(this.testData.data);
      //   console.log(this.testData);
      if (this.testData.hasOwnProperty("data")) {
        if (this.testData.data.hasOwnProperty("userhead")) {
          this.imgUrl =
            this.$http.defaults.baseURL +
            "file" +
            "/" +
            this.testData.data.userhead;
        }
      }

      // if (this.testData.type == 0) {

      // }
      this.$emit("userChild", this.testData);
    },
    handleCommand(command) {
      if (command == 1) {
        this.$router.push("/users");
      } else if (command == 2) {
        this.$confirm("确认要退出系统么?", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("userId");
            window.sessionStorage.removeItem("userType");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/index");
            this.$router.go(0);
          })
          .catch(() => {});
      }
    }
  },
  watch: {
    $route(to) {
      this.routerPath = to.path;
    },
    toUpdate(to) {
      if (to) {
        if (this.token !== null) {
          this.getRouterData();
        }
      }
    }
  },
  computed: {
    reversedMessage: function() {
      return this.username.replace(/(^\d{3}|\d{4}\B)/g, "$1-");
    }
  },
  created() {
    this.routerPath = this.$route.path;

    if (this.token !== null) {
      this.getRouterData();
    }
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
// .el-menu {
//   background-image: url(../assets/img/71ef113f33848c6fdbe5cb709cb29d1.png);
// }
li {
  list-style-type: none;
}
ul {
  margin: 0;
  padding: 0;
}
.el-menu-demo {
  border-bottom: 0px !important;
}
.box {
  width: 100%;
  height: 100%;
}
/* 版心 */
.w {
  width: 1190px;
  margin: 0 auto;
}

.router-link-login {
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
// .router-link-exact-active {
//   background: rgba(0, 136, 255);
// }
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 3px solid #409eff !important;
}
#menu .no_active {
  border-bottom: 0px !important;
}
.el-menu-item {
  font-weight: 600;
}
@media (max-width: 1303px) {
  #menu .el-menu-item {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
@media (max-width: 1204px) {
  #menu .el-menu-item {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
#logo_hover:hover {
  background-color: transparent !important;
}
#user_hover:hover {
  background-color: transparent !important;
}
.el-menu-item:hover {
  background: rgba(0, 136, 255) !important;
}
.SmartEarth_active {
  text-decoration: none;
}
.el-dropdown-link {
  color: #fff;
  // font-style: normal;
  font-weight: 600;
}
.el-header {
  background: url(../assets/img/71ef113f33848c6fdbe5cb709cb29d1.png) no-repeat;

  background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;

  .el-dropdown-link {
    color: #fff;
    font-style: normal;
    font-weight: 600;
  }
}
</style>
